export default {
    data() {
        return {
            dev: window.location.hostname=='localhost',
            windowWidth: window.innerWidth,
            sites: [
                {
                    name: 'concordance',
                    url: 'https://concordance.apcom.ch',
                    url_dev: 'http://localhost:3000',
                    api: '/api/img',
                    image_width:200,
                    image_height:200,
                    cover: false,
                },
                {
                    name: 'Armis',
                    url: 'https://demos.armis.ch',
                    url_dev: 'https://demos.armis.ch',
                    api: '/api',
                    image_width:1200,
                    image_height:1200,
                    cover: true,
                },
                {
                    name: 'Maison du chasseur',
                    url: 'https://preprod.maisonduchasseur.ch',
                    url_dev: 'https://preprod.maisonduchasseur.ch',
                    api: '/api',
                    image_width:1200,
                    image_height:1200, 
                    cover: true,
                }
            ], 
        }
    },
    mounted() {
        window.onresize = () => {
            this.windowWidth = window.innerWidth
        }
    },
    methods: {
        set_axios(){
            axios.defaults.baseURL = localStorage.getItem('site_url') + localStorage.getItem('api');
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('user-token');
        },
        date_display(date){
            if(date) return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
        },
        time_display(date){
            if(date) return moment(date, 'YYYY-MM-DD h:mm:ss').format('hh:mm:ss');
        },
        isEmpty(obj) {
            for(var key in obj) {
                if(obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        },
        toFormData: function(obj){
            var form_data = new FormData();
            for(var key in obj){
                if(obj[key] !== null && key!== 'image')   form_data.append(key, obj[key]);
            }
            return form_data;
        },
        logFormData(formData){
            // Display the key/value pairs
            for (var pair of formData.entries()) {
                console.log(pair[0]+ ', ' + pair[1]);
            }
        },
        nullData:function(obj){
            for(var key in obj){
                    obj[key]=null;
            }
            return obj;
        },
        show_price(number) {
            return number.toFixed(2);
        },
        getUrl(url, filtername, id ){
            return window.App.baseurl + url + '?' + filtername + '=' + id;
        },
        color_switch(active) {
            return active? 'success': 'default'
        },
        toggleActive(url,active){
            axios.patch( window.App.baseurl + url, {
                'active': active
            });
        },
        arrayRemove(arr, value) {
            return arr.filter(function(ele){
                return ele != value;
            });
        },
        boldString(str, find){
            if(str !== undefined && str !==null){
                var re = new RegExp(find, 'g');
                return str.replace(re, '<b>'+find+'</b>');
            }
        },
        getImgUrl(image_path){
            if(!image_path) return null;
            if( image_path.charAt(0) !== '/') image_path = '/' + image_path;             
            return localStorage.getItem('site_url') + image_path;
        },
    }
}